import React from 'react'
import PropTypes from 'prop-types'
import qs from 'qs'

import {useFetch} from '../lib/use-fetch'
import Spinner from '../lib/spinner'
import SocialLogin from '../components/SocialLogin'
import {authorizeEndpoint, setClientKeyEndpoint} from '../components/consts'
import {redirectToAuthorize} from '../utils'
import {generateAndSaveOauthState} from '../lib/oauthState'

function Login ({location}) {
  const {loading} = useFetch('GET', setClientKeyEndpoint)
  if (loading) {
    return <Spinner />
  }

  const {search} = location
  const {appId, providerId, redirect} = qs.parse(search, {ignoreQueryPrefix: true})
  if (appId && !providerId) {
    return (
      <SocialLogin
        appId={appId}
        authorizeUrl={authorizeEndpoint}
        redirectUrl={redirect}
      />
    )
  }

  const state = generateAndSaveOauthState()
  const query = qs.stringify({appId, providerId, redirect, state}, {addQueryPrefix: true})
  redirectToAuthorize(query)
  return null
}

Login.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired
}

export default Login
